const buildIsoWeekCompatabilityError = () => {
  const error = new Error();
  error.name = 'Iso - Week targeting cannot be used interchangeably';
  return error;
};

export default buildIsoWeekCompatabilityError;
